function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 7H7C6.447 7 6 6.553 6 6C6 5.447 6.447 5 7 5H12C12.553 5 13 5.447 13 6C13 6.553 12.553 7 12 7ZM11 11H7C6.447 11 6 10.553 6 10C6 9.447 6.447 9 7 9H11C11.553 9 12 9.447 12 10C12 10.553 11.553 11 11 11ZM15 7C14.447 7 14 6.553 14 6C14 5.447 14.447 5 15 5C15.553 5 16 5.447 16 6C16 6.553 15.553 7 15 7ZM7 15C6.447 15 6 14.553 6 14C6 13.447 6.447 13 7 13C7.553 13 8 13.447 8 14C8 14.553 7.553 15 7 15Z"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 2C2 1.44772 2.44772 1 3 1H15.999C17.6563 1 19 2.34371 19 4.001V10C19 10.5523 18.5523 11 18 11C17.4477 11 17 10.5523 17 10V4.001C17 3.44828 16.5517 3 15.999 3H3C2.44772 3 2 2.55228 2 2Z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 3C2.22428 3 2 3.22428 2 3.5C2 3.77572 2.22428 4 2.5 4H3V3.5C3 3.22428 2.77572 3 2.5 3ZM5 3.5C5 2.11972 3.88028 1 2.5 1C1.11972 1 0 2.11972 0 3.5C0 4.88028 1.11972 6 2.5 6H3V17C3 18.6563 4.34372 20 6 20H7C7.55228 20 8 19.5523 8 19C8 18.4477 7.55228 18 7 18H6C5.44828 18 5 17.5517 5 17V3.5Z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 12.915,
  y: 12,
  width: 4,
  height: 5,
  rx: 2
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.915 17.8137C13.915 17.6905 13.8046 17.5964 13.6838 17.6209C11.8401 17.994 10.4045 19.2118 10.0181 21.007C9.90187 21.547 10.3628 22 10.915 22H18.915C19.4673 22 19.9282 21.547 19.812 21.007C19.3808 19.0035 17.6426 17.7191 15.4888 17.5255C15.4308 17.5203 15.3734 17.5416 15.3322 17.5828L14.915 18L14.2565 18.6586C14.1305 18.7846 13.915 18.6953 13.915 18.5172V17.8137Z"
});

var SvgUserAudit = function SvgUserAudit(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22",
      fill: "none"
    }, props), _ref, _ref2, _ref3, _ref4, _ref5)
  );
};

export default SvgUserAudit;